import React from "react";

const ImportantInstructionsCard = ({ onClose }) => {
  return (
    <div className="w-full flex justify-center absolute top-4 left-0 z-50 px-4">
      <div
        className="bg-white shadow-xl rounded-2xl p-6 md:p-8 max-w-3xl w-full border border-gray-200"
        dir="rtl"
      >
        {/* Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-red-600 text-center mb-4">
          تعليمات هامة
        </h2>

        {/* Instructions */}
        <ul className="text-gray-700 space-y-3 leading-relaxed md:text-lg text-base">
          <li>1- وانت بتعمل حساب لازم تكون بياناتك صحيحة (اسمك رباعي - رقم الواتساب بتاعك - رقم ولي أمرك).</li>
          <li>2- لازم تحفظ الباسورد بتاعك.</li>
          <li>3- كل فيديو في المنصة متاح تفتحه 5 مرات فقط، فلازم تتأكد إن الشبكة كويسة قبل ما تفتح الفيديو.</li>
          <li>4- يجب الالتزام بمشاهدة الفيديوهات وحل الواجب والامتحانات.</li>
          <li>5- يتم ارسال تقرير دوري بالمستوى لولي الأمر.</li>
          <li>6- أي طالب غير ملتزم مش هنكمل معاه.</li>
          <li>7- مشاهدة الفيديو تُحتسب بعد مشاهدة 30% من مدته.</li>
          <li>8- الاشتراك في امتحانات الدور الأول وفيه استرجاع لسعر الكورس.</li>
        </ul>

        {/* Button */}
        <div className="flex justify-center mt-6">
          <button
            onClick={onClose}
            className="bg-red-600 text-white py-2 px-10 rounded-xl text-lg hover:bg-red-700 transition"
          >
            حسناً
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImportantInstructionsCard;
